(() => {
  'use strict';

  const SELECTORS = {
    container: '.product__lower',
    slot: '.convert-buy-button-slot',
    originalQuantity: '[data-convert-original="quantity"], .product__lower-quantity:not(.convert-product__lower-quantity)',
    originalStock: '[data-convert-original="stock"], .js-stock-info, .product__lower-stock:not(.convert-product__lower-stock)',
    convertButton: '.convert-buy-button-slot button[type="submit"], .convert-buy-button-slot .product-form__submit',
    originalInput: 'input[name="id"]:not(.convert-buy-button-slot input), select[name="id"]:not(.convert-buy-button-slot select)'
  };

  const MAX_ATTEMPTS = 40;
  const DELAY = 100;

  let currentVariant = 'control';
  let stockObserver = null;
  let cachedSlotHTML = null;

  const resurrectSlot = () => {
    if (!cachedSlotHTML) return null;

    const originalBlock = document.querySelector(SELECTORS.originalQuantity);
    const container = document.querySelector(SELECTORS.container);

    if (originalBlock && originalBlock.parentNode) {
      originalBlock.parentNode.insertBefore(cachedSlotHTML, originalBlock.nextSibling);
    } else if (container) {
      container.appendChild(cachedSlotHTML);
    }

    return document.querySelector(SELECTORS.slot);
  };

  const waitForSlot = (callback, attempts = 0) => {
    let slot = document.querySelector(SELECTORS.slot);

    if (slot) {
      if (!cachedSlotHTML) cachedSlotHTML = slot.cloneNode(true);
      callback(slot);
      return;
    }

    if (!slot && cachedSlotHTML && attempts > 0) {
      slot = resurrectSlot();
      if (slot) {
        callback(slot);
        return;
      }
    }

    if (attempts >= MAX_ATTEMPTS) return;

    setTimeout(() => waitForSlot(callback, attempts + 1), DELAY);
  };

  const getSourceStockElement = () => {
    let candidates = document.querySelectorAll('[data-convert-original="stock"]');
    for (let el of candidates) {
      if (!el.closest(SELECTORS.slot)) return el;
    }

    candidates = document.querySelectorAll('.js-stock-info, .product__lower-stock');
    for (let el of candidates) {
      if (!el.closest(SELECTORS.slot) && !el.closest('.convert-stock-info')) {
        return el;
      }
    }
    return null;
  };

  const syncVariantId = () => {
    const sourceInput = document.querySelector(SELECTORS.originalInput);
    const slot = document.querySelector(SELECTORS.slot);
    if (!slot) return;
    
    const targetInput = slot.querySelector('input[name="id"], select[name="id"]');

    if (sourceInput && targetInput) {
      targetInput.value = sourceInput.value;
      if (targetInput.tagName === 'SELECT') {
         targetInput.value = sourceInput.value; 
      }
    }

    // Sync delivery date input
    const sourceDeliveryInput = document.querySelector('.product__lower-quantity:not(.convert-product__lower-quantity) .delivery-date-input');
    const targetDeliveryInput = slot.querySelector('.delivery-date-input');
    
    if (sourceDeliveryInput && targetDeliveryInput) {
      targetDeliveryInput.value = sourceDeliveryInput.value;
    }
  };

  const syncVariantLabel = () => {
    const variantSelects = document.querySelector('variant-selects, variant-radios');
    const convertLabels = document.querySelectorAll('.convert-variant-label');
    
    if (!variantSelects || !convertLabels.length) return;
    
    const currentVariant = variantSelects.currentVariant;
    if (!currentVariant || !currentVariant.options) return;
    
    convertLabels.forEach((label) => {
      const optionIndex = parseInt(label.getAttribute('data-option-index'));
      const valueSpan = label.querySelector('.js-convert-option-value');
      
      if (valueSpan && currentVariant.options[optionIndex]) {
        valueSpan.textContent = currentVariant.options[optionIndex];
      }
    });
  };

  const syncFakeColourLabel = () => {
    const sourceLabel = document.querySelector('product-colour-variants .js-option-value');
    const convertLabel = document.querySelector('.js-convert-fake-colour-value');
    
    if (sourceLabel && convertLabel) {
      convertLabel.textContent = sourceLabel.textContent;
    }
  };

  const syncStockInfo = () => {
    const source = getSourceStockElement();
    const target = document.querySelector('.convert-stock-info');

    if (!source || !target) return;

    target.innerHTML = source.innerHTML;
    target.style.display = 'block';
    target.removeAttribute('hidden');

    const stockBlock = target.querySelector('.product__lower-stock');
    if (stockBlock) {
      stockBlock.classList.add('convert-product__lower-stock');
      stockBlock.classList.remove('hide-all');
      stockBlock.style.display = 'block';
    }
    
    syncVariantLabel();
    syncVariantId();
  };

  const syncStockInfoWithRetry = (attempts = 0) => {
    const source = getSourceStockElement();
    if (!source && attempts < MAX_ATTEMPTS) {
      setTimeout(() => syncStockInfoWithRetry(attempts + 1), DELAY);
      return;
    }
    syncStockInfo();
  };

  const observeStockInfo = () => {
    if (stockObserver) return;
    const source = getSourceStockElement();
    if (!source) return;

    stockObserver = new MutationObserver(() => syncStockInfo());
    stockObserver.observe(source, {
      childList: true,
      subtree: true,
      attributes: true
    });
  };

  const disconnectStockObserver = () => {
    if (stockObserver) {
      stockObserver.disconnect();
      stockObserver = null;
    }
  };

  const toggleOriginalBlocks = (hide) => {
    const elements = document.querySelectorAll(`${SELECTORS.originalQuantity}, ${SELECTORS.originalStock}`);

    elements.forEach(el => {
      if (el.closest(SELECTORS.slot)) return;

      if (hide) {
        el.setAttribute('hidden', '');
        el.style.setProperty('display', 'none', 'important');
        el.dataset.convertHidden = 'true';
      } else {
        el.removeAttribute('hidden');
        el.style.removeProperty('display');
        el.removeAttribute('data-convert-hidden');
      }
    });
  };

  const paintButton = (color) => {
    const button = document.querySelector(SELECTORS.convertButton);
    if (!button) return;
    button.style.setProperty('background-color', color, 'important');
    button.style.setProperty('border-color', color, 'important');
  };

  const activateVariant = (callback) => {
    waitForSlot((slot) => {
      disconnectStockObserver();

      slot.removeAttribute('hidden');
      slot.style.removeProperty('display');

      toggleOriginalBlocks(true);

      syncStockInfoWithRetry();
      syncVariantLabel();
      syncFakeColourLabel();
      syncVariantId();
      observeStockInfo();

      callback?.();
    });
  };

  document.addEventListener('productLowerUpdated', () => {
    if (currentVariant !== 'control') {
      disconnectStockObserver();

      setTimeout(() => {
        if (currentVariant === 'v2') window.convertPdpVariants.v2();
        if (currentVariant === 'v3') window.convertPdpVariants.v3();
      }, 100);
    }
  });

  if (window.subscribe && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, () => {
      if (currentVariant !== 'control') {
        setTimeout(() => {
          syncVariantLabel();
          syncVariantId();
        }, 50);
      }
    });
  }

  document.addEventListener('colorVariantChanged', () => {
    if (currentVariant !== 'control') {
      setTimeout(() => {
        syncFakeColourLabel();
        syncVariantId();
      }, 100);
    }
  });

  window.convertPdpVariants = {
    control() {
      currentVariant = 'control';
      const slot = document.querySelector(SELECTORS.slot);
      if (slot) slot.style.display = 'none';

      toggleOriginalBlocks(false);
      disconnectStockObserver();

      document.documentElement.classList.remove('convert-v2', 'convert-v3');
      document.documentElement.removeAttribute('data-convert-variant');
    },
    v2() {
      currentVariant = 'v2';
      activateVariant(() => {
        document.documentElement.classList.add('convert-v2');
        document.documentElement.classList.remove('convert-v3');
        document.documentElement.setAttribute('data-convert-variant', 'v2');
      });
    },
    v3() {
      currentVariant = 'v3';
      activateVariant(() => {
        paintButton('#1f8f5b');
        document.documentElement.classList.add('convert-v3');
        document.documentElement.classList.remove('convert-v2');
        document.documentElement.setAttribute('data-convert-variant', 'v3');
      });
    },
    reset() {
      this.control();
    }
  };

  document.addEventListener('page:load', () => window.convertPdpVariants.control?.());
})();
